export const selectCropsUpdatedAt = (state) => state.sync.cropsUpdatedAt

export const selectBullUpdatedAt = state => state.sync.bullUpdatedAt

export const selectProductsUpdatedAt = state => state.sync.productsUpdatedAt

export const selectMilkDataUpdatedAt = state => state.sync.milkDataUpdatedAt

export const selectMilkDataLoading = state => state.sync.milkDataLoading

export const selectProductsLoading = state => state.sync.productsLoading

export const selectShoppingOrganizationsUpdatedAt = state => state.sync.shoppingOrganizationsUpdatedAt

export const selectShoppingOrganizationsLoading = state => state.sync.shoppingOrganizationsLoading


